import { ReportTourDetailShowModel } from 'api-hooks/report';
import { themedStyled } from 'common/styles/styletron.theme';
import LoadingComponent from 'components/common/loading';
import { MasterDatePicker, MasterInput } from 'components/elements/master';
import {
  CardSection,
  OneThirdContainer,
  SectionContainer as RawSectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  data?: ReportTourDetailShowModel;
  isLoading: boolean;
}

export default function TourDetailShowCard(props: Props) {
  const { data, isLoading } = props;
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <CardSection>
        <LoadingComponent />
      </CardSection>
    );
  }

  return (
    <CardSection>
      <SectionContainer>
        <OneThirdContainer>
          <MasterInput
            type="text"
            label={t('common:tour_code')}
            value={data?.code}
            disabled
          />
        </OneThirdContainer>
        <OneThirdContainer>
          <MasterInput
            type="text"
            label={t('common:tour_name')}
            value={data?.name}
            disabled
          />
        </OneThirdContainer>
        <OneThirdContainer>
          <MasterInput
            type="text"
            label={t('common:total_participant')}
            value={(data?.totalParticipant || 0).toString()}
            disabled
          />
        </OneThirdContainer>
      </SectionContainer>
      <SectionContainer>
        <OneThirdContainer>
          <MasterDatePicker
            label={t('common:departed_at')}
            value={data?.departedAt}
            disabled
          />
        </OneThirdContainer>
        <OneThirdContainer>
          <MasterDatePicker
            label={t('common:transaction_at')}
            value={data?.transactionAt}
            disabled
          />
        </OneThirdContainer>
        <OneThirdContainer>
          <MasterDatePicker
            label={t('common:completed_at')}
            value={data?.completedAt}
            disabled
          />
        </OneThirdContainer>
      </SectionContainer>
    </CardSection>
  );
}

const SectionContainer = themedStyled(RawSectionContainer, {
  width: '100%',
});
